// extracted by mini-css-extract-plugin
export default {"price":"XUnyk","increased":"ARlnF","decreased":"dLV_H"};